import { buildHtmlContext, createBasicRenderer, Html, observable } from "@chorda/core";
export const createChordaWebComponent = (options, styles) => {
    const attrs = {
        active: (v) => JSON.parse(v)
    };
    return class extends HTMLElement {
        constructor() {
            super();
            const context = {
                active: observable(false),
                onClick: (e) => {
                    e.stopPropagation();
                    this.dispatchEvent(new Event('click', {}));
                },
            };
            this.__html = new Html(options || {}, Object.assign({}, buildHtmlContext(createBasicRenderer())), context);
            this.attachShadow({ mode: 'open' });
            if (styles) {
                const style = document.createElement('style');
                style.innerHTML = styles;
                this.shadowRoot.append(style);
            }
        }
        connectedCallback() {
            this.__html.attach(this.shadowRoot);
        }
        disconnectedCallback() {
            this.__html.detach();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            console.log(name, newValue, oldValue);
            this.__html.scope[name].$value = attrs[name](newValue);
        }
        static get observedAttributes() {
            return Object.keys(attrs);
        }
    };
};
